import { Icon } from '@chakra-ui/react';

export const ColorLens = (props) => (
  <Icon viewBox="0 0 25 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M12.6665 18C9.3605 18 6.6665 15.306 6.6665 12C6.6665 8.694 9.3605 6 12.6665 6C15.9725 6 18.6665 8.424 18.6665 11.4C18.6665 13.386 17.0525 15 15.0665 15H14.0045C13.8365 15 13.7045 15.132 13.7045 15.3C13.7045 15.372 13.7345 15.438 13.7825 15.498C14.0285 15.78 14.1665 16.134 14.1665 16.5C14.1665 17.328 13.4945 18 12.6665 18ZM12.6665 7.2C10.0205 7.2 7.8665 9.354 7.8665 12C7.8665 14.646 10.0205 16.8 12.6665 16.8C12.8345 16.8 12.9665 16.668 12.9665 16.5C12.9665 16.404 12.9185 16.332 12.8825 16.29C12.6365 16.014 12.5045 15.66 12.5045 15.3C12.5045 14.472 13.1765 13.8 14.0045 13.8H15.0665C16.3925 13.8 17.4665 12.726 17.4665 11.4C17.4665 9.084 15.3125 7.2 12.6665 7.2Z"
      fill="#666666"
    />
    <path
      d="M9.3665 12.6C9.86356 12.6 10.2665 12.1971 10.2665 11.7C10.2665 11.2029 9.86356 10.8 9.3665 10.8C8.86945 10.8 8.4665 11.2029 8.4665 11.7C8.4665 12.1971 8.86945 12.6 9.3665 12.6Z"
      fill="#666666"
    />
    <path
      d="M11.1665 10.2C11.6636 10.2 12.0665 9.79706 12.0665 9.3C12.0665 8.80294 11.6636 8.4 11.1665 8.4C10.6694 8.4 10.2665 8.80294 10.2665 9.3C10.2665 9.79706 10.6694 10.2 11.1665 10.2Z"
      fill="#666666"
    />
    <path
      d="M14.1665 10.2C14.6636 10.2 15.0665 9.79706 15.0665 9.3C15.0665 8.80294 14.6636 8.4 14.1665 8.4C13.6694 8.4 13.2665 8.80294 13.2665 9.3C13.2665 9.79706 13.6694 10.2 14.1665 10.2Z"
      fill="#666666"
    />
    <path
      d="M15.9665 12.6C16.4636 12.6 16.8665 12.1971 16.8665 11.7C16.8665 11.2029 16.4636 10.8 15.9665 10.8C15.4694 10.8 15.0665 11.2029 15.0665 11.7C15.0665 12.1971 15.4694 12.6 15.9665 12.6Z"
      fill="#666666"
    />
  </Icon>
);
